import { render } from "./BackgroundPepsico.vue?vue&type=template&id=46c0ee9c"
import script from "./BackgroundPepsico.vue?vue&type=script&lang=js"
export * from "./BackgroundPepsico.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\Vue3\\player-video-pepsi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__